import {
	Modal,
	ModalBackdrop,
	ModalButtons,
	ModalCloseButton,
	ModalText,
	ModalTitle,
	PrimaryButton,
} from "components/Common";
import React, {useCallback, useEffect, useState} from "react";
import {IconClose} from "components/Icons";
import {useTranslation} from "react-i18next";
import styled from "@emotion/styled";
import {useDispatch, useSelector} from "react-redux";
import {getUserStore} from "modules/selectors";
import {sendWhatsNewModalViewed} from "modules/actions";

const SModalTitle = styled(ModalTitle)`
	margin-top: 24px;
`;

export const ChangelogModal: React.FC = () => {
	const dispatch = useDispatch();
	const [isOpen, setIsOpen] = useState(false);
	const {t} = useTranslation();
	const user = useSelector(getUserStore).currentUser;

	useEffect(() => {
		if (!user) {
			return;
		}
		if (!user.isWhatsNewModalViewed) {
			setIsOpen(true);
		}
	}, [user]);

	const closeModal = useCallback(() => {
		setIsOpen(false);
		dispatch(sendWhatsNewModalViewed());
	}, [dispatch]);

	if (!isOpen) {
		return null;
	}

	return (
		<ModalBackdrop>
			<Modal>
				<ModalCloseButton onClick={closeModal}>
					<IconClose />
				</ModalCloseButton>

				<SModalTitle>{t("modal.changelog.title")}</SModalTitle>
				<ModalText>{t("modal.changelog.text")}</ModalText>

				<ModalButtons>
					<PrimaryButton onClick={closeModal}>{t("modal.changelog.close")}</PrimaryButton>
				</ModalButtons>
			</Modal>
		</ModalBackdrop>
	);
};
